<template>
  <div class="loading">
    <div class="loading__loader" ref="loader"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import lottie from "lottie-web";

const loader = ref(null);

onMounted(async () => {
  if (loader.value) {
    try {
      // Use dynamic import to load the JSON animation data
      const animationModule = await import("../../public/loader_1.json");
      const animationData = animationModule.default || animationModule;
      
      lottie.loadAnimation({
        container: loader.value,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
    } catch (error) {
      console.error("Failed to load lottie animation:", error);
    }
  }
});
</script>

<style scoped lang="scss">
.loading {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(var(--modal-bg-1), 0.5);

  &__loader {
    width: 200px;
    height: 200px;
  }
}
</style>
